<template>
<div class="chapter">
<div class="inner_page">
      ﻿<meta content="text/html; charset=utf-8" http-equiv="Content-Type"/><meta content="text/html; charset=UTF-8"/><title> STRANGE FIRE </title><link href="default.css" rel="stylesheet" type="text/css"/>
<p class="cta" id="p0019-01-0"><a id="page1"></a><a href="#/chapter2#ii4" id="tt4">PART ONE</a></p>
<p class="ser1"><img alt="978140020518_0007_002.jpg" class="maxwidth" src="images/978140020518_0007_002.jpg"/></p>
<p class="ct1" id="p0019-02-1"><a href="#/chapter2#ii4">C<span class="small">ONFRONTING A</span> C<span class="small">OUNTERFEIT</span> R<span class="small">EVIVAL</span></a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chapter4.vue?0c2b89a9